import { env } from "@/env";

let clientStarted = false;
const listeners = new Set<() => void>();

/** Preserve the SDK's project-scoped key; the same owner configures createClient. */
export function supabaseSessionStorageKey(): string {
  return `sb-${new URL(env.NEXT_PUBLIC_SUPABASE_URL).hostname.split(".")[0]}-auth-token`;
}

/** A loading hint only. Supabase still restores and validates the actual session. */
export function needsSupabaseSession(): boolean {
  if (typeof window === "undefined") return false;
  if (clientStarted) return true;
  try {
    const url = new URL(window.location.href);
    const fragment = new URLSearchParams(url.hash.slice(1));
    if (
      url.searchParams.has("code") ||
      fragment.has("access_token") ||
      fragment.has("error_description") ||
      url.searchParams.has("error_description")
    )
      return true;
    return window.localStorage.getItem(supabaseSessionStorageKey()) !== null;
  } catch {
    // Denied storage or unknown configuration is not proof of an anonymous visit.
    return true;
  }
}

/** Other same-tab callers (account, OAuth, chat) must also wake the header. */
export function markSupabaseClientStarted(): void {
  if (typeof window === "undefined" || clientStarted) return;
  clientStarted = true;
  for (const listener of listeners) listener();
}

export function onSupabaseClientStarted(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
